import { appMessage as message } from "../utils/appMessage";
import apiClient from "../utils/apiClient";
import i18n from "../i18n";

export const signup = async (email, username, password) => {
  try {
    const { data } = await apiClient.post("/api/auth/signup", {
      email,
      username,
      password,
    });

    if (!data.ok) {
      // Handle validation errors
      if (data.details) {
        const errorMessages = data.details.map((err) => err.msg).join(", ");
        throw new Error(errorMessages);
      }
      throw new Error(data.error || data.message || "Signup failed");
    }

    message.success(data.message || i18n.t("auth.signup.messages.accountCreated"));
    return { success: true, message: data.message };
  } catch (err) {
    const responseData = err?.response?.data;
    const errorMessage =
      responseData?.error || responseData?.message || err.message || "Signup failed";
    const i18nKey = responseData?.i18nKey || null;
    return { success: false, error: errorMessage, i18nKey };
  }
};
